import React, { useEffect, useState } from "react";
import { Box, Popover, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { styles } from "../../../assets/MUIStyles/agentStyle";
import CommonModal from "../CommonComponents/Modal/CommonModal";
import { getAllCustomersAction } from "../Customer/Store/customers.action";
import {
  getTestAgentProgressAction,
  testAgentProgressAction,
} from "../ProjectSection/Agents/Store/Agent.action";
import TestAgent from "./TestAgent";
import TestChat from "./TestChat";
import TestsSection from "./TestsSection";

const TestProgress = ({ testProgressModal, selectedAgent: agent, toggle }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null) as any;
  const [progressData, setProgressData] = useState(null) as any;
  const [testAgentModal, setTestAgentModal] = useState(false);
  const [state, setState] = useState({
    loadingButtons: {},
    selectedAgent: agent,
    chatData: [] as any,
    checkStatusError: false,
    allTests: [],
  });
  const { selectedAgent, chatData, checkStatusError, loadingButtons } = state;

  useEffect(() => {
    testAgentProgress();
    getTestCustomers();
  }, [dispatch]);

  useEffect(() => {
    if (checkStatusError) {
      const timeout = setTimeout(() => {
        setAnchorEl(null);
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, [checkStatusError]);

  const testAgentProgress = async () => {
    const testAgentRes: any = await dispatch(
      getTestAgentProgressAction(selectedAgent?._id)
    );
    setState((prev) => ({
      ...prev,
      allTests: testAgentRes,
    }));
  };

  const getTestCustomers = async () => {
    const params = {
      pageIndex: 1,
      pageSize: 1000,
    };
    await dispatch(getAllCustomersAction(params));
  };

  const handleLatestStatus = async (id: string, event: React.MouseEvent) => {
    setAnchorEl(event.currentTarget);

    setState((prev) => ({
      ...prev,
      loadingButtons: { ...prev.loadingButtons, [id]: true },
    }));

    try {
      const res: any = await dispatch(testAgentProgressAction(id));
      if (res?.status === 200) {
        if (res?.data?.progress === "100.0%") {
          testAgentProgress();
        } else {
          setProgressData(res?.data);
          setState((prev) => ({
            ...prev,
            loadingButtons: { ...prev.loadingButtons, [id]: false },
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching status:", error);
      setState((prev) => ({
        ...prev,
        loadingButtons: { ...prev.loadingButtons, [id]: false },
        checkStatusError: true,
      }));
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setProgressData(null);
  };

  const open =
    (Boolean(anchorEl) &&
      (checkStatusError || progressData) &&
      !Object.values(state.loadingButtons || {}).some((loading) => loading)) ||
    false;
  const id = open ? "progress-popover" : undefined;

  return (
    <>
      <CommonModal
        heading="Test Progress"
        body={
          <TestsSection
            state={state}
            setState={setState}
            handleLatestStatus={handleLatestStatus}
          />
        }
        show={testProgressModal}
        toggle={toggle}
        footer={false}
        handleSave={false}
        size={900}
      />

      {chatData?.length > 0 && (
        <TestChat chatData={chatData} setState={setState} />
      )}

      {testAgentModal && (
        <TestAgent
          testAgentModal={testAgentModal}
          toggle={() => setTestAgentModal(false)}
          selectedAgent={selectedAgent}
        />
      )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        sx={{ p: 2 }}
      >
        {loadingButtons &&
        Object.values(loadingButtons).some((loading) => loading) ? null : (
          <Box
            sx={{
              p: 2,
              width: 250,
              textAlign: "center",
            }}
          >
            {checkStatusError ? (
              <>
                <Typography color="red">Something Went Wrong </Typography>
                <Typography>Please Try Again </Typography>
              </>
            ) : progressData ? (
              <>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    textTransform: "none",
                  }}
                >
                  Test Progress
                </Typography>

                <Box className="flex-align-center gap-1 mt-2">
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {progressData.progress}
                  </Typography>

                  <Box
                    sx={{
                      flex: 1,
                      height: 8,
                      borderRadius: 4,
                      bgcolor: "#E0E0E0",
                    }}
                  >
                    <Box sx={styles.testAgentModal2(progressData)} />
                  </Box>
                </Box>

                <Box className="flex-justify-center mt-2">
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    Status:
                  </Typography>
                  <Box className="ml-1">
                    <Typography sx={styles.testAgentModal(progressData.status)}>
                      {progressData.status.toUpperCase().replace("_", " ")}
                    </Typography>
                  </Box>
                </Box>
              </>
            ) : (
              <Typography variant="body2">No Data Available</Typography>
            )}
          </Box>
        )}
      </Popover>
    </>
  );
};

export default TestProgress;
